import { useEffect } from "react";

function ChatWidget({ apiKey }) {
  useEffect(() => {
    // Create script element
    const script = document.createElement("script");
    script.src = "https://support.oasislogic.tech/chatbot.js";
    script.setAttribute("data-bot-id", apiKey || "034ca541ee25294c4c87b96405d675bc2dae1d05d215be8c0b871031f4cc6e09");
    script.setAttribute("data-position", "bottom-right");
    script.setAttribute("data-color", "#00ccff");

    // Append to body
    document.body.appendChild(script);
    // Cleanup function
    return () => {
      document.body.removeChild(script);
    };
  }, [apiKey]);

  return null; // This component doesn't render anything
}

// Use in your layout
function Layout({ children }) {
  // You can store your API key in environment variables
  const apiKey = "034ca541ee25294c4c87b96405d675bc2dae1d05d215be8c0b871031f4cc6e09";

  return (
    <>
      {children}
      <ChatWidget apiKey={apiKey} />
    </>
  );
}

export default Layout;
